import { 
  Lightbulb, Palette, Upload, Loader2
} from "lucide-react";

/**
 * StrategyStage - Choose workflow: Compose OR Upload Completed Video
 */
export function StrategyStage({
  onStrategyChoice,
  onUploadSceneVideo,
  uploadingVideo
}) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-4" data-testid="strategy-stage">
      <div className="text-center max-w-2xl mx-auto">
        <Lightbulb className="w-16 h-16 mx-auto mb-6 text-amber-500" />
        <h2 className="text-2xl font-bold text-white mb-2">Choose Your Workflow</h2>
        <p className="text-zinc-400 mb-8">
          How would you like to proceed with this shot?
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Option 1: Compose */}
          <button
            onClick={() => onStrategyChoice("compose")}
            className="group p-6 rounded-xl border-2 border-zinc-700 hover:border-indigo-500 bg-zinc-900/50 hover:bg-indigo-900/20 transition-all text-left"
            data-testid="strategy-compose-btn"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-full bg-indigo-500/20 flex items-center justify-center">
                <Palette className="w-6 h-6 text-indigo-400" />
              </div>
              <h3 className="text-lg font-semibold text-white group-hover:text-indigo-300">Compose</h3>
            </div>
            <p className="text-sm text-zinc-400 group-hover:text-zinc-300">
              Set up your shot, create your animation, and apply optional lip sync.
            </p>
          </button>
          
          {/* Option 2: Upload */}
          <label className="group p-6 rounded-xl border-2 border-zinc-700 hover:border-purple-500 bg-zinc-900/50 hover:bg-purple-900/20 transition-all text-left cursor-pointer">
            <input
              type="file"
              accept="video/*"
              className="hidden"
              onChange={onUploadSceneVideo}
              data-testid="strategy-upload-input"
            />
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-full bg-purple-500/20 flex items-center justify-center">
                {uploadingVideo ? (
                  <Loader2 className="w-6 h-6 text-purple-400 animate-spin" />
                ) : (
                  <Upload className="w-6 h-6 text-purple-400" />
                )}
              </div>
              <h3 className="text-lg font-semibold text-white group-hover:text-purple-300">
                {uploadingVideo ? "Uploading..." : "Upload"}
              </h3>
            </div>
            <p className="text-sm text-zinc-400 group-hover:text-zinc-300">
              Already have a finished video for this shot? Upload it directly and skip to the Print stage.
            </p>
          </label>
        </div>
      </div>
    </div>
  );
}

export default StrategyStage;
